import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Section } from '../shared';

import CharacterContent from './CharacterContent';

import { maxWidth } from '../../helpers/media-queries';

const Wrapper = styled.div `
    &:before, &:after {
        content: '';
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
    }

    &:before {
        top: 10px;
        left: 10px;
        background-image: url(./static/images/characters/bright-1.png);
        height: 6px;
        width: 198px;
    }

    &:after {
        bottom: 10px;
        right: 0px;
        background-image: url(./static/images/characters/bright-2.png);
        height: 34px;
        width: 76px;
    }
`;

const styles = ({ palette, sizes }) => {
    return {
        root: {
            '& h3': {
                textAlign: 'left',
                color: '#ffffff',
                lineHeight: '0.5em',
                paddingBottom: '0.5em',
                fontSize: '4em',
                [maxWidth.md]: {
                    fontSize: '3.5em',
                },

                [maxWidth.lg]: {
                    borderWidth: '22px 22px 30px 22px',
                },
        
            },
            '& .wrapper': {                
                position: 'relative',
                borderStyle: 'solid',
                borderWidth: '32px 32px 40px 32px',
                borderImage: 'url(./static/images/characters/border.png) 110 139 137 137 fill / 1 / 0 round',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                flex: 1,
                width: '100%',
                [maxWidth.lg]: {
                    width: 'calc(100% - 4px)',
                    margin: 'auto',
                },
            },
            '& .character-info-wrapper': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '70% 800px, 0 0, 0',
                backgroundPosition: 'left center',
                color: '#ffffff',
                padding: `${sizes.baseSize * 2}px ${sizes.baseSize}px`,
                width: '100%',
                [maxWidth.md]: {
                    backgroundSize: '0 0, 2000px 100%, auto 600px',
                    backgroundPosition: 'left center, center 215px, center top',
                    flexDirection: 'column-reverse',
                    padding: '25px 0',
                }
            },
            '& .character-image': {
                [maxWidth.md]: {
                    height: '400px',
                }
            },
            '& .character-image img': {
                position: 'absolute',
                width: `calc(125% + ${sizes.baseSize * 6}px)`,
                height: 'auto',
                bottom: '-'+(sizes.baseSize * 2)+'px',
                right: '-'+(sizes.baseSize * 6)+'px',

                [maxWidth.md]: {
                    display: 'none',
                }
            }
        }
    }
};

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    character: stores.characters.character,
})

class Characters extends Component {
    render() {
        const { character, classes } = this.props;

        return (
            <Section className={classes.root} id="sesion-personajes">
                <Wrapper className="wrapper">
                    <div className="character-info-wrapper" style={{
                        backgroundColor: character.color, 
                        backgroundImage: `
                            url(./static/images/characters/box-pattern.png), 
                            url(./static/images/characters/box-pattern-vertical.png),
                            url(${character.src.replace('.png', '-mobile.png')})`
                        }}>
                        <CharacterContent />
                    </div>
                </Wrapper>
            </Section>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(Characters)
);